export default __webpack_public_path__ + "static/media/svg-6.d86deeb4.svg";